// 导入路由模块
import { createRouter, createWebHistory } from "vue-router"; // 修改这里
// 定义路由规则
const Home = () => import("./../views/home.vue");
const About = () => import("./../views/about.vue");

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/about",
    component: About,
  },
];

export default createRouter({
  // 引用路由规则
  routes,
  // 指定路由模式，
  history: createWebHistory(), // 修改这里
});
